import React, { useState } from "react";
import alertify from "alertifyjs";

const UserDelete = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setPhoneNumber(value);
    }
  };

  const handleOtpChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,6}$/.test(value)) {
      setOtp(value);
    }
  };

  const handleDeleteClick = () => {
    if (phoneNumber.length !== 10) {
      alertify.error("Phone number must be exactly 10 digits.");
    } else {
      setShowOtpModal(true);
    }
  };

  const handleOtpSubmit = () => {
    if (otp.length !== 6) {
      alertify.error("OTP must be exactly 6 digits.");
      return;
    }

    console.log("Phone number deleted:", phoneNumber, "OTP:", otp);
    alertify.success("User account deleted successfully!");

    // Reset form
    setPhoneNumber("");
    setOtp("");
    setShowOtpModal(false);
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f9f9f9",
      }}
    >
      <div
        style={{
          maxWidth: 500,
          width: "100%",
          padding: "20px",
          border: "1px solid #ccc",
          borderRadius: 8,
          background: "white",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <h2>Delete Account</h2>
        <p
          style={{
            marginTop: "10px",
            fontSize: "14px",
            marginBottom: "10px",
          }}
        >
          Enter your registered 10-digit mobile number to delete your account.
        </p>

        <input
          type="text"
          placeholder="Enter 10-digit number"
          className="form-control"
          value={phoneNumber}
          onChange={handlePhoneChange}
          style={{ width: "100%", padding: "10px", marginTop: "10px" }}
        />

        <button
          onClick={handleDeleteClick}
          style={{
            marginTop: "15px",
            padding: "10px 20px",
            width: "100%",
            background: "#d32f2f",
            color: "white",
            border: "none",
            borderRadius: 4,
          }}
        >
          Delete Account
        </button>
      </div>

      {/* OTP Modal */}
      {showOtpModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: 8,
              maxWidth: 500,
              height: 200,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            }}
          >
            <h3
              style={{
                fontSize: "18px",
                marginBottom: "10px",
              }}
            >
              Enter OTP
            </h3>
            <input
              type="text"
              placeholder="Enter 6-digit OTP"
              value={otp}
              className="form-control"
              onChange={handleOtpChange}
              style={{ width: "100%", padding: "10px", marginTop: "10px" }}
            />

            <button
              onClick={handleOtpSubmit}
              style={{
                marginTop: "15px",
                padding: "10px 20px",
                width: "100%",
                background: "#1976d2",
                color: "white",
                border: "none",
                borderRadius: 4,
              }}
            >
              Confirm Deletion
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDelete;
